// extracted by mini-css-extract-plugin
module.exports = {"colTable":"style_colTable__3Jr1F","titleCol":"style_titleCol__3uMa_","editable_cell_value_wrap":"style_editable_cell_value_wrap__3oeRo"};